import * as React from 'react';
import { Accordion } from '@grandvisionhq/common';
import { FacetId } from '../../../../../types.js';
import { FacetContainerMobile } from '../../../FacetContainerMobile/FacetContainerMobile.js';
import { ConnectedFacetInputPriceRangeMobile } from '../../../FacetInputPriceRange/ConnectedFacetInputPriceRangeMobile.js';

const ConnectedFacetsContainer = ({ facets , onChange  })=>{
    return /*#__PURE__*/ React.createElement(Accordion, {
        className: "connected-facets-container"
    }, facets.map((facet)=>{
        const FacetComponent = facet.id === FacetId.price ? ConnectedFacetInputPriceRangeMobile : FacetContainerMobile;
        return /*#__PURE__*/ React.createElement(FacetComponent, {
            key: facet.attribute,
            facet: facet,
            onChange: onChange
        });
    }));
};

export { ConnectedFacetsContainer };
//# sourceMappingURL=ConnectedFacetsContainer.js.map
